import React from "react";
import CSSModules from "react-css-modules";

import styles from "./AuthLayout.less";

@CSSModules(styles)
class AuthLayoutContainer extends React.PureComponent {
  render() {
    return (
      <div styleName="container-outer">
        <div styleName="container-inner">{this.props.children}</div>
      </div>
    );
  }
}

@CSSModules(styles)
class AuthLayoutBox extends React.PureComponent {
  render() {
    return (
      <div styleName="box">
        {this.props.title && <div styleName="box-title">{this.props.title}</div>}
        <div styleName="box-content">{this.props.children}</div>
      </div>
    );
  }
}

export default {
  Container: AuthLayoutContainer,
  Box: AuthLayoutBox,
};



// WEBPACK FOOTER //
// ./src/modules/app/AuthLayout.jsx